import Image from '@base/Image';
import GoesLiveInTimer from './GoesLiveInTimer';
import SubmitAnswerTimer from './SubmitAnswerTimer';
import useQuizStatus from '../../Common/useQuizStatus';
import LiveImage from './LiveImage';

const DefaultEmptyImage = 'quiz/default-empty.svg';

const Illustration = ({ isOffline }) => {
  const { isLive, toBeHeldToday, isSubjectiveAnswerUploadPending } =
    useQuizStatus();

  if (isSubjectiveAnswerUploadPending && !isOffline) {
    return <SubmitAnswerTimer />;
  }

  if (isLive) {
    return <LiveImage />;
  }

  if (toBeHeldToday) {
    return <GoesLiveInTimer />;
  }

  return (
    <Image height={260} width={360} src={DefaultEmptyImage} alt="default" />
  );
};

export default Illustration;
